<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { firebaseConfig } from "../config";
  import Navbar from "../components/donorflow-ui/Navbar.svelte";
  import { fade } from "svelte/transition";
  import { donationboxes } from "../stores";
  import Cookies from "js-cookie";

  let db;
  let loading = true;
  let pages = [];
  let portalId;
  let hasData = false;
  let isError;
  let errorMessage = "";

  function getPages(id) {
    return db
      .collection("pages")
      .where("portalId", "==", id)
      .orderBy("createdAt", "desc")
      .get()
      .then((snapShot) => {
        if (snapShot.size > 0) {
          snapShot.forEach((i) => {
            let d = i.data();
            pages = [
              ...pages,
              {
                id: i.id,
                ...d,
              },
            ];
          });
          hasData = true;
          loading = false;
        } else {
          hasData = false;
          loading = false;
        }
      })
      .catch((e) => {
        console.log(e);
        alert(
          "🤨 An error occured. We could not get pages this time. Try refreshing the page. \n If the problem continues, contact support@donorflow.net"
        );
        loading = false;
        isError = true;
        errorMessage = "Could not connect. Refresh the page to try again.";
      });
  }

  function goTo(page_id) {
    push("/page/" + page_id);
  }

  async function getContent() {
    return db
      .collection("donationboxes")
      .where("portalId", "==", "5G5P22a7QI22FGt9koFI")
      .get()
      .then((docs) => {
        docs.forEach((doc) => {
          $donationboxes = [...$donationboxes, { id: doc.id, ...doc.data() }];
        });
      });
  }

  onMount(() => {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    portalId = localStorage.getItem("portal");

    db = firebase.firestore();
    getContent().then(() => {
      getPages(portalId);
    });
  });
</script>

<Navbar
  showSecondary={true}
  secondaryNavItems={[
    { label: "Campaign Pages", path: "/" },
    { label: "Settings", path: "/settings" },
  ]}
/>

<div style="background: #FFF08E; height: 200px;" />

<div style="margin-top: -180px;" in:fade>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <h2>
          Campaign Pages
          <span style="float: right;"
            ><button class="btn btn-default" on:click={() => push("/new")}
              ><i class="bx bx-plus" />
              Add</button
            ></span
          >
        </h2>
        <div style="height: 40px" />
        {#if isError}
          <div class="alert alert-warning">
            {errorMessage}
          </div>
        {/if}
        <div class="card shadow-sm border-none" style="min-height: 400px;">
          <div class="card-body">
            <div style="height: 40px;width: 100%;" />
            {#if loading}
              <!-- content here -->
              Loading...
            {:else}
              <!-- else content here -->
              <!-- content here -->
              {#if hasData}
                {#each pages as page}
                  <div
                    class="card-item-row d-flex align-items-center"
                    on:click={() => goTo(page.id)}
                  >
                    <div style="margin-left:15px;width:400px;font-size:1.1rem;">
                      <a href="#/page/{page.id}">{page.name}</a>
                    </div>
                    <div style="flex:1;" class="chevron-link">
                      <a href="#/page/{page.id}">
                        <span style="float: right;"
                          ><i class="bx bxs-chevron-right" /></span
                        >
                      </a>
                    </div>
                  </div>
                {/each}
              {:else}
                <p>
                  You have not created any pages yet. <a href="#/new"
                    >Create a page</a
                  >
                </p>
              {/if}
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .border-none {
    border: none;
  }
  h2 {
    font-size: 1.4rem;
  }
  .img-placeholder {
    width: 80px;
    height: 53px;
    background: #dddddd;
    border-radius: 3px;
  }
  .chevron-link {
    font-size: 1.2rem;
  }
  .chevron-link i {
    padding: 5px;
    background: #ffffff;
    border-radius: 50%;
  }
  .card-item-row {
    /* border-radius: 7px; */
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
    padding: 20px 15px;
  }
  .card-item-row:hover {
    background: #f1f1f1;
  }
</style>
